/* Customer-facing cart properties only; internal manufacturing data stays verbatim. */
(function () {
  'use strict';
  const labels = {
    de: ['Extras', 'Für', 'Fertigungszeit', 'Konfiguration', 'Warenkorb wird aktualisiert …', 'Die Sprache konnte nicht aktualisiert werden. Bitte erneut versuchen.'],
    en: ['Extras', 'For', 'Production time', 'Configuration', 'Updating cart …', 'The language could not be updated. Please try again.'],
    fr: ['Options', 'Pour', 'Délai de fabrication', 'Configuration', 'Mise à jour du panier …', 'La langue n’a pas pu être mise à jour. Veuillez réessayer.'],
    es: ['Extras', 'Para', 'Plazo de fabricación', 'Configuración', 'Actualizando el carrito …', 'No se pudo actualizar el idioma. Inténtalo de nuevo.'],
    ja: ['オプション', '対象', '製作期間', '構成', 'カートを更新中 …', '言語を更新できませんでした。もう一度お試しください。'],
  };
  const decode = value => String(value).replace(/&#39;|&quot;|&amp;/g, entity => ({'&#39;': "'", '&quot;': '"', '&amp;': '&'}[entity]));
  const daysText = (n, lang) => ({de: `${n} Werktag${n === 1 ? '' : 'e'}`, en: `${n} business day${n === 1 ? '' : 's'}`, fr: `${n} jour${n === 1 ? '' : 's'} ouvré${n === 1 ? '' : 's'}`, es: `${n} día${n === 1 ? '' : 's'} hábil${n === 1 ? '' : 'es'}`, ja: `${n}営業日`}[lang]);
  function duration(value, lang) {
    const match = String(value).match(/^(\d+)\s*(?:Werktage?|business days?|jours? ouvrés?|días? hábil(?:es)?|営業日)(.*)$/u);
    if (!match) return null;
    const suffix = match[2];
    if (!suffix) return daysText(Number(match[1]), lang);
    const date = suffix.match(/^(?:, (?:gerechnet ab |counted from |à compter du |a partir del ))(.+)$/u) || suffix.match(/^、(.+)から起算$/u);
    if (!date) return null;
    return daysText(Number(match[1]), lang) + ({de: `, gerechnet ab ${date[1]}`, en: `, counted from ${date[1]}`, fr: `, à compter du ${date[1]}`, es: `, a partir del ${date[1]}`, ja: `、${date[1]}から起算`}[lang]);
  }
  function plan(cart, lang, dictionary) {
    if (!labels[lang]) return [];
    const names = new Map();
    for (const translations of Object.values(dictionary)) {
      if (!translations[lang]) continue;
      for (const value of Object.values(translations)) if (value) names.set(decode(value), decode(translations[lang]));
    }
    const alternatives = [...names.keys()].sort((a,b) => b.length-a.length).map(s => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
    const pattern = new RegExp('(^|, )(' + alternatives.join('|') + ')(?=, |$)', 'gu');
    const translate = value => decode(value).replace(pattern, (_, prefix, name) => prefix + names.get(name));
    return cart.items.flatMap(item => {
      const original = item.properties || {};
      if (!original._rxk_group) return [];
      const properties = {...original};
      for (let role=0; role<4; role++) {
        const keys = [...new Set(Object.values(labels).map(row => row[role]))];
        const present = keys.filter(key => typeof original[key] === 'string' && original[key]);
        if (present.length !== 1) continue;
        const key = present[0];
        let value = original[key];
        if (role === 0) value = translate(value);
        if (role === 1) {
          const parents = cart.items.filter(parent => parent.handle !== 'roxxlyn-upgrade' && parent.properties?._rxk_group === original._rxk_group);
          if (parents.length !== 1) continue;
          value = parents[0].product_title || value;
        }
        if (role === 2) { value = duration(value, lang); if (value === null) continue; }
        if (role === 3 && !/^#\d+$/.test(value)) continue;
        delete properties[key];
        properties[labels[lang][role]] = value;
      }
      const equal = Object.keys(original).length === Object.keys(properties).length && Object.keys(original).every(key => original[key] === properties[key]);
      return equal ? [] : [{id:item.key, quantity:item.quantity, properties}];
    });
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = {plan, duration}; return; }
  const config = document.querySelector('[data-rxk-cart-locale]');
  if (!config || window.Shopify?.designMode) return;
  const lang = document.documentElement.lang.split('-')[0];
  if (!labels[lang]) return;
  let dictionary;
  let pending;
  let bypass = false;
  const request = async (url, options = {}) => {
    const response = await fetch(url, {...options, credentials:'same-origin', cache:'no-store', signal:AbortSignal.timeout(15000)});
    if (!response.ok) throw Error('Cart locale request failed');
    return response.json();
  };
  async function sync(target = lang) {
    const roots = JSON.parse(config.dataset.roots);
    if (!roots[target]) return false;
    const root = roots[target];
    let cart = await request(root + 'cart.js');
    if (!cart.items.some(item => item.properties?._rxk_group)) return false;
    dictionary ||= await request(config.dataset.dictionary);
    let changes = plan(cart, target, dictionary);
    if (!changes.length) return false;
    const dialog = document.createElement('dialog');
    dialog.setAttribute('aria-label', labels[lang][4]);
    dialog.textContent = labels[lang][4];
    dialog.style.cssText = 'border:1px solid #ccc;padding:24px;background:white;color:black;max-width:calc(100% - 32px)';
    dialog.addEventListener('cancel', event => event.preventDefault());
    document.body.append(dialog);
    dialog.showModal();
    try {
      let count = 0;
      // Refresh each key: Shopify changes line keys when properties change.
      while (changes.length && count++ < 100) {
        cart = await request(root + 'cart.js');
        changes = plan(cart, target, dictionary);
        if (!changes.length) break;
        const change = changes[0];
        const updated = await request(root + 'cart/change.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(change)});
        if (updated.item_count !== cart.item_count || updated.total_price !== cart.total_price) throw Error('Cart changed during translation');
        if (plan(updated, target, dictionary).some(next => next.id === change.id)) throw Error('Cart translation not applied');
        changes = plan(updated, target, dictionary);
      }
      if (changes.length) throw Error('Cart translation incomplete');
      return true;
    } finally { dialog.remove(); }
  }
  function run(target) {
    if (pending) return pending;
    const work = () => sync(target);
    pending = (navigator.locks ? navigator.locks.request('rxk-cart-locale', work) : work()).finally(() => { pending = null; });
    return pending;
  }
  const fail = error => { console.warn('Cart language update:', error.message); window.alert(labels[lang][5]); };
  document.addEventListener('submit', async event => {
    if (bypass) return;
    const form = event.target;
    const button = event.submitter;
    const isLanguage = new URL(form.action, location.href).pathname.endsWith('/localization');
    const target = isLanguage ? (['language_code', 'locale_code'].includes(button?.name) ? button.value : (new FormData(form).get('language_code') || new FormData(form).get('locale_code'))) : lang;
    const isCheckout = button?.name === 'checkout';
    if ((!isLanguage && !isCheckout) || !labels[target]) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    try {
      await run(target);
      bypass = true;
      try {
        // Kasse: form.submit() statt requestSubmit(), damit kein zweites submit-Ereignis entsteht.
        // Sonst fängt die Reservierungsprüfung des Konfigurators es ab, schickt es erneut,
        // und beide Prüfungen geben sich den Klick endlos zurück (Kasse unerreichbar, 01.10.2026).
        if (isCheckout) {
          const field = document.createElement('input');
          field.type = 'hidden'; field.name = 'checkout'; field.value = button.value || '';
          form.append(field);
          HTMLFormElement.prototype.submit.call(form);
        } else form.requestSubmit(button || undefined);
      } finally { bypass = false; }
    } catch (error) { fail(error); }
  }, true);
  document.addEventListener('click', async event => {
    const link = event.target.closest('a[href]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.button !== 0) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !/\/(?:cart\/)?checkout\/?$/.test(url.pathname)) return;
    event.preventDefault();event.stopImmediatePropagation();
    try { await run(lang); location.assign(url.href); } catch (error) { fail(error); }
  }, true);
  if (/\/cart\/?$/.test(location.pathname)) run(lang).then(changed => { if (changed) location.reload(); }).catch(fail);
})();
